<template>
<about-us-section :section="feedbackSection" :section-class="sectionClass">
  <template slot="content">
    <feedback-form :title="section.title"
                   :content="section.content"
                   :label="section.label"
    ></feedback-form>
  </template>
</about-us-section>
</template>

<script>
import Vue from 'vue'
import AboutUsSection from './AboutUsSection'
import FeedbackForm from '@/components/feedback/FeedbackForm'
import HasSectionHighlights from '@/mixins/HasSectionHighlights'

export default Vue.extend({
  props: ['section', 'namespace'],

  mixins: [HasSectionHighlights],

  components: {
    AboutUsSection,
    FeedbackForm,
  },

  computed: {
    feedbackSection() {
      return {
        ...this.section,
        withoutHeading: true,
        title: '',
        content: '',
      }
    },

    sectionClass() {
      return `about-us-feedback-section${this.sectionHighlightClasses}`
    }
  },

  methods: {
    getSectionNamespace() {
      return this.namespace
    },
  },
})
</script>

<style lang="less">
.about-us-feedback-section {
  .static-container {
    @apply max-w-md;
  }
}
</style>
